import { render, staticRenderFns } from "./ProductTabCategories.vue?vue&type=template&id=c134c71a&scoped=true&"
import script from "./ProductTabCategories.vue?vue&type=script&lang=js&"
export * from "./ProductTabCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabCategories.vue?vue&type=style&index=0&id=c134c71a&lang=scss&scoped=true&"
import style1 from "./ProductTabCategories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c134c71a",
  null
  
)

export default component.exports